import React from 'react';
import { Alert, Spin, Typography } from 'antd';

import type { InspectAssessmentPeriod } from '../../../../state/app/inspect_assessment/types';
import { formatAssessmentDate } from './formatters';

type Props = {
  periods: InspectAssessmentPeriod[];
  fetching: boolean;
  error?: string;
  selectedAssessmentId?: number;
  selectedPeriodIndex?: number;
  onSelectPeriod: (periodIndex: number) => void;
};

const PeriodSidecar: React.FC<Props> = ({
  periods,
  fetching,
  error,
  selectedAssessmentId,
  selectedPeriodIndex,
  onSelectPeriod,
}) => (
  <nav
    aria-label="Assessment periods"
    className="assessment-inspect-assessment__period-sidecar"
  >
    <div className="assessment-inspect-assessment__period-heading">
      Periods
    </div>
    <div className="assessment-inspect-assessment__period-list">
      {fetching ? (
        <Spin size="small" />
      ) : error ? (
        <Alert
          className="assessment-inspect-assessment__period-error"
          type="error"
          showIcon
          message="Period dates unavailable"
          description={error}
        />
      ) : selectedAssessmentId === undefined ? (
        <Typography.Text type="secondary">
          Select an assessment to see its periods
        </Typography.Text>
      ) : periods.length === 0 ? (
        <Typography.Text type="secondary">
          No period dates available
        </Typography.Text>
      ) : (
        periods.map(period => (
          <button
            type="button"
            key={period.index}
            className={`assessment-inspect-assessment__period-row ${
              period.index === selectedPeriodIndex
                ? 'assessment-inspect-assessment__period-row--active'
                : ''
            }`}
            onClick={() => onSelectPeriod(period.index)}
          >
            <span className="assessment-inspect-assessment__period-label">
              {period.label}
            </span>
            <span className="assessment-inspect-assessment__period-date">
              {formatAssessmentDate(period.scenario_date)}
            </span>
          </button>
        ))
      )}
    </div>
  </nav>
);

export default PeriodSidecar;
